import { render } from "./VendorTables.vue?vue&type=template&id=6c3b9731"
import script from "./VendorTables.vue?vue&type=script&lang=js"
export * from "./VendorTables.vue?vue&type=script&lang=js"

import "./VendorTables.vue?vue&type=style&index=0&id=6c3b9731&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__